<template>
  <v-dialog v-model="dialogVisible" max-width="600px">
    <BaseBodyDialog :title="title" @close="close" @save="save">
      <v-form class="mt-6" ref="form" v-model="valid">
        <v-text-field
          v-model="editedItem.name"
          label="Tên mẫu"
          :rules="[(v) => !!v || 'Tên mẫu là bắt buộc']"
          required
          outlined
          dense
        ></v-text-field>
        <v-select
          v-model="editedItem.type"
          :items="typeOptions"
          label="Loại mẫu"
          :rules="[(v) => !!v || 'Loại mẫu là bắt buộc']"
          required
          outlined
          dense
        ></v-select>
        <v-select
          v-model="editedItem.evaluate_criteria"
          :items="evaluateCriterias"
          item-text="title"
          item-value="id"
          label="Chọn tiêu chí đánh giá"
          :rules="[(v) => (v && v.length > 0) || 'Phải chọn ít nhất một tiêu chí đánh giá']"
          multiple
          chips
          outlined
          dense
          required
        >
          <template v-slot:selection="{ item, index }">
            <v-chip class="my-2" v-if="index < 5" small>
              <span>{{ item.title }}</span>
              <v-icon small right @click.stop="removeCriteria(item.id)">mdi-close</v-icon>
            </v-chip>
            <span v-else-if="index === 5" class="grey--text text-caption">
              (+{{ editedItem.evaluate_criteria ? editedItem.evaluate_criteria.length - 5 : 0 }} others)
            </span>
          </template>
        </v-select>
      </v-form>
    </BaseBodyDialog>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'

export default {
  name: 'EvaluateTemplateDialog',
  components: {
    BaseBodyDialog
  },
  props: {
    value: Boolean,
    title: String,
    item: Object,
  },
  data() {
    return {
      valid: false,
      editedItem: {
        id: '',
        name: '',
        type: '',
        evaluate_criteria: [],
      },
      typeOptions: [{ text: 'Theo buổi', value: 'session' }],
    }
  },
  computed: {
    ...mapState('evaluateCriteria', ['evaluateCriterias']),
    dialogVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    item: {
      handler(newItem) {
        if (newItem) {
          const parseItem = JSON.parse(JSON.stringify(newItem))
          this.editedItem = {
            id: parseItem.id,
            name: parseItem.name,
            type: parseItem.type,
            evaluate_criteria: parseItem.evaluate_criteria.map((criteria) => criteria.id),
          }
        } else {
          this.resetForm()
        }
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.dialogVisible = false
      this.resetForm()
    },
    save() {
      if (this.$refs.form.validate()) {
        const savedItem = {
          ...this.editedItem,
          evaluate_criteria: this.editedItem.evaluate_criteria
            ? this.editedItem.evaluate_criteria.map((id) =>
                this.evaluateCriterias.find((criteria) => criteria.id === id)
              )
            : [],
        }
        this.$emit('save', savedItem)
        this.close()
      }
    },
    removeCriteria(id) {
      if (this.editedItem.evaluate_criteria) {
        this.editedItem.evaluate_criteria = this.editedItem.evaluate_criteria.filter((criteriaId) => criteriaId !== id)
      }
    },
    resetForm() {
      this.$refs.form.reset()
      this.editedItem = {
        id: '',
        name: '',
        type: '',
        evaluate_criteria: [],
      }
    },
  },
}
</script>
